export const BurgerMenu = ({ className }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <line
        x1="0.5"
        y1="14.9004"
        x2="0.5"
        y2="17.5004"
        stroke="black"
        strokeLinecap="round"
      />
      <line
        x1="0.5"
        y1="7.69922"
        x2="0.5"
        y2="10.2992"
        stroke="#E5E5E5"
        strokeLinecap="round"
      />
      <line
        x1="0.5"
        y1="0.5"
        x2="0.5"
        y2="3.1"
        stroke="#238CBC"
        strokeLinecap="round"
      />
      <line
        x1="14.8999"
        y1="16.3008"
        x2="17.4999"
        y2="16.3008"
        stroke="black"
        strokeLinecap="round"
      />
      <line
        x1="14.8999"
        y1="9.09961"
        x2="17.4999"
        y2="9.09961"
        stroke="#E5E5E5"
        strokeLinecap="round"
      />
      <line
        x1="14.8999"
        y1="1.90039"
        x2="17.4999"
        y2="1.90039"
        stroke="#238CBC"
        strokeLinecap="round"
      />
      <path
        d="M16.7998 16.5C16.7998 17.3284 16.1282 18 15.2998 18H1.49981C0.671379 18 -0.00019455 17.3284 -0.00019455 16.5V15.9C-0.00019455 15.0716 0.671378 14.4 1.49981 14.4H15.2998C16.1282 14.4 16.7998 15.0716 16.7998 15.9V16.5Z"
        fill="black"
      />
      <path
        d="M16.7998 9.29883C16.7998 10.1273 16.1282 10.7988 15.2998 10.7988L1.49981 10.7988C0.671379 10.7988 -0.00019455 10.1273 -0.00019455 9.29883V8.69883C-0.00019455 7.8704 0.671378 7.19883 1.49981 7.19883L15.2998 7.19883C16.1282 7.19883 16.7998 7.8704 16.7998 8.69883V9.29883Z"
        fill="#E5E5E5"
      />
      <path
        d="M16.7998 2.09961C16.7998 2.92804 16.1282 3.59961 15.2998 3.59961L1.49981 3.59961C0.671379 3.59961 -0.00019455 2.92804 -0.00019455 2.09961V1.49961C-0.00019455 0.671183 0.671378 -0.00039053 1.49981 -0.00039053L15.2998 -0.00039053C16.1282 -0.00039053 16.7998 0.671183 16.7998 1.49961V2.09961Z"
        fill="#238CBC"
      />
    </svg>
  );
};
export const ArrowLeft = ({ className }) => {
  return (
    <svg
      width="6"
      height="11"
      viewBox="0 0 6 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.12595 11L0.181021 5.94661C-0.0603403 5.69995 -0.0603403 5.30004 0.181021 5.05339L5.12595 0L6 0.893076L1.49209 5.5L6 10.1069L5.12595 11Z"
        fill="white"
      />
    </svg>
  );
};
export const ArrowDown = ({ className }) => {
  return (
    <svg
      width="6"
      height="3"
      viewBox="0 0 6 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.99995 3C2.89246 3 2.78494 2.964 2.70296 2.89216L0.123085 0.629161C-0.0410283 0.485209 -0.0410283 0.251815 0.123085 0.107921C0.287132 -0.0359733 0.553161 -0.0359733 0.717288 0.107921L2.99995 2.11031L5.28271 0.10806C5.44675 -0.0358338 5.71282 -0.0358338 5.87685 0.10806C6.04105 0.251954 6.04105 0.485278 5.87685 0.629231L3.29702 2.89224C3.215 2.96407 3.10748 3 2.99995 3Z"
        fill="white"
      />
    </svg>
  );
};
export const ArrowRight = ({ className }) => {
  return (
    <svg
      width="5"
      height="10"
      viewBox="0 0 5 10"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M0.728374 10L4.84915 5.40601C5.05028 5.18178 5.05028 4.81822 4.84915 4.59399L0.728374 0H0.5L0 0.5V0.811887L3.75659 5L0 9.18811V9.5L0.5 10H0.728374Z" />
    </svg>
  );
};
export const Location = ({ className }) => {
  return (
    <svg
      width="13"
      height="20"
      viewBox="0 0 13 20"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.78262 6.03853C8.78262 7.55448 7.55373 8.78311 6.03804 8.78311C4.52235 8.78311 3.29346 7.55448 3.29346 6.03853C3.29346 4.52284 4.52235 3.29395 6.03804 3.29395C7.55373 3.29395 8.78262 4.52284 8.78262 6.03853Z"
        fillOpacity="0.8"
        fill="transparent"
      />
      <path d="M11.5272 18.1145C11.5272 17.2051 9.06963 16.4678 6.03799 16.4678C3.00635 16.4678 0.548828 17.2051 0.548828 18.1145C0.548828 19.0242 3.00635 19.7613 6.03799 19.7613C9.06963 19.7613 11.5272 19.0242 11.5272 18.1145Z" />
      <path d="M6.03807 0C2.70411 0.0021442 0.0021442 2.70438 0 6.03808C0 8.88156 4.30341 15.0129 5.36828 16.4841C5.49479 16.6543 5.57707 16.7639 5.59905 16.7969C5.70251 16.9352 5.8652 17.0164 6.03807 17.0164C6.21095 17.0164 6.37364 16.9352 6.4771 16.7969C6.49908 16.7639 6.58163 16.6543 6.70787 16.4841C7.77273 15.0129 12.0761 8.88156 12.0761 6.03808C12.074 2.70438 9.37204 0.0021442 6.03807 0ZM6.03807 15.5345C4.33638 13.1467 1.09783 8.17344 1.09783 6.03808C1.09783 3.30985 3.30958 1.09783 6.03807 1.09783C8.76657 1.09783 10.9783 3.30985 10.9783 6.03808C10.9783 8.17344 7.73977 13.1467 6.03807 15.5345Z" />
      <path d="M6.03813 2.74414C4.21931 2.74414 2.74463 4.21882 2.74463 6.03764C2.74463 7.85673 4.21931 9.33114 6.03813 9.33114C7.85721 9.33114 9.33162 7.85673 9.33162 6.03764C9.33162 4.21882 7.85721 2.74414 6.03813 2.74414ZM6.03813 8.23331C4.82558 8.23331 3.84246 7.25046 3.84246 6.03764C3.84246 4.82509 4.82558 3.84197 6.03813 3.84197C7.25067 3.84197 8.23379 4.82509 8.23379 6.03764C8.23379 7.25046 7.25067 8.23331 6.03813 8.23331Z" />
    </svg>
  );
};
export const Clock = ({ className }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1289_8533)">
        <path
          d="M12.5 25C9.18479 25 6.00537 23.683 3.66117 21.3388C1.31696 18.9946 0 15.8152 0 12.5C0 9.18479 1.31696 6.00537 3.66117 3.66117C6.00537 1.31696 9.18479 0 12.5 0C15.8152 0 18.9946 1.31696 21.3388 3.66117C23.683 6.00537 25 9.18479 25 12.5C25 15.8152 23.683 18.9946 21.3388 21.3388C18.9946 23.683 15.8152 25 12.5 25ZM12.5 22.5C15.1522 22.5 17.6957 21.4464 19.5711 19.5711C21.4464 17.6957 22.5 15.1522 22.5 12.5C22.5 9.84783 21.4464 7.3043 19.5711 5.42893C17.6957 3.55357 15.1522 2.5 12.5 2.5C9.84783 2.5 7.3043 3.55357 5.42893 5.42893C3.55357 7.3043 2.5 9.84783 2.5 12.5C2.5 15.1522 3.55357 17.6957 5.42893 19.5711C7.3043 21.4464 9.84783 22.5 12.5 22.5ZM11.25 13.0125V5H13.75V11.9875L18.6875 16.925L16.925 18.6875L11.25 13.0125Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1289_8533">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Phone = ({ className }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M11.946 9.56544L11.8863 9.38548C11.7448 8.96501 11.2811 8.52649 10.8552 8.41095L9.27864 7.98028C8.8511 7.86396 8.24124 8.02036 7.92844 8.33314L7.35785 8.90372C5.28424 8.3434 3.65821 6.71732 3.09864 4.64411L3.66925 4.0735C3.98205 3.7607 4.13843 3.15164 4.02211 2.72411L3.59222 1.14679C3.4759 0.720035 3.03658 0.256363 2.61691 0.116459L2.43695 0.0559501C2.01648 -0.0839538 1.41683 0.0575345 1.10405 0.370313L0.250543 1.2246C0.0980648 1.37627 0.000612429 1.81009 0.000612429 1.81168C-0.0292394 4.52148 1.03331 7.13225 2.95011 9.04908C4.86222 10.9612 7.4632 12.0222 10.1651 11.9994C10.1793 11.9994 10.6257 11.9035 10.7781 11.7518L11.6317 10.8983C11.9444 10.5855 12.0859 9.98591 11.946 9.56544Z" />
    </svg>
  );
};
export const Email = ({ className }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M0.25057 2.23022C1.89752 3.62501 4.78741 6.07887 5.63679 6.84398C5.75081 6.94725 5.87311 6.99975 6.00007 6.99975C6.12677 6.99975 6.24886 6.94774 6.36262 6.84497C7.21273 6.0791 10.1026 3.62501 11.7496 2.23022C11.8521 2.14355 11.8678 1.9912 11.7847 1.88524C11.5928 1.64039 11.3067 1.5 11.0001 1.5H1.00008C0.693445 1.5 0.407297 1.64039 0.215414 1.88527C0.132398 1.9912 0.148031 2.14355 0.25057 2.23022Z" />
      <path d="M11.855 2.9862C11.7664 2.94495 11.6621 2.95934 11.5884 3.02234C9.76195 4.57067 7.43091 6.55531 6.6975 7.21618C6.28587 7.58775 5.71458 7.58775 5.30198 7.21568C4.52025 6.51134 1.90256 4.286 0.411609 3.02232C0.337383 2.95932 0.232898 2.94542 0.145008 2.98617C0.0566484 3.02721 0 3.1156 0 3.213V9.50011C0 10.0516 0.448477 10.5001 1.00001 10.5001H11C11.5515 10.5001 12 10.0516 12 9.50011V3.213C12 3.1156 11.9434 3.02698 11.855 2.9862Z" />
    </svg>
  );
};
export const Information = ({ className }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.5 0.195312C5.72266 0.195312 0.195312 5.72266 0.195312 12.5C0.195312 19.2773 5.72266 24.8047 12.5 24.8047C19.2773 24.8047 24.8047 19.2773 24.8047 12.5C24.8047 5.72266 19.2773 0.195312 12.5 0.195312ZM12.5 23.2422C6.58203 23.2422 1.75781 18.418 1.75781 12.5C1.75781 6.58203 6.58203 1.75781 12.5 1.75781C18.418 1.75781 23.2422 6.58203 23.2422 12.5C23.2422 18.418 18.418 23.2422 12.5 23.2422Z"
        fill="white"
      />
      <path d="M13.2812 10.6445H11.7188V18.457H13.2812V10.6445Z" fill="white" />
      <path
        d="M13.2812 6.93359H11.7188V8.49609H13.2812V6.93359Z"
        fill="white"
      />
    </svg>
  );
};
export const WorkMF = ({ className }) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="#121218"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M44.8472 1.9084H43.1327C43.177 1.76641 43.2228 1.62443 43.2228 1.46718C43.2228 0.658015 42.5633 0 41.7526 0C40.9419 0 40.2854 0.658015 40.2854 1.46718C40.2854 1.62443 40.3281 1.76641 40.3755 1.9084H34.7572C34.8014 1.76641 34.8472 1.62443 34.8472 1.46718C34.8442 0.658015 34.1877 0 33.3755 0C32.5663 0 31.9083 0.658015 31.9083 1.46718C31.9083 1.62443 31.9526 1.76641 31.9984 1.9084H26.377C26.4213 1.76641 26.4671 1.62443 26.4671 1.46718C26.4671 0.658015 25.8106 0 24.9999 0C24.1892 0 23.5327 0.658015 23.5327 1.46718C23.5327 1.62443 23.5755 1.76641 23.6213 1.9084H18.0014C18.0457 1.76641 18.0915 1.62443 18.0915 1.46718C18.0915 0.658015 17.4335 0 16.6243 0C15.8136 0 15.1556 0.658015 15.1556 1.46718C15.1556 1.62443 15.1984 1.76641 15.2442 1.9084H9.62586C9.67166 1.76641 9.71593 1.62443 9.71593 1.46718C9.71593 0.656489 9.05944 0 8.24876 0C7.43807 0 6.78006 0.658015 6.78006 1.46718C6.78006 1.62443 6.8228 1.76641 6.86861 1.9084H5.15258C2.83502 1.9084 0.954102 3.79084 0.954102 6.10687V45.8015C0.954102 48.1191 2.83502 50 5.15258 50H40.1068L49.0457 41.0611V6.10687C49.0457 3.79084 47.1648 1.9084 44.8472 1.9084ZM46.7556 40.1115L46.2808 40.5863H42.6854C41.003 40.5863 39.632 41.9603 39.632 43.6397V47.2351L39.1572 47.7099H5.15258C4.10067 47.7099 3.24418 46.8534 3.24418 45.8015V13.7405H46.7556V40.1115Z"
        fillOpacity="0.9"
      />
      <path
        d="M7.24 37V23H11.34L14.68 28.42L18.02 23H22.12V37H18.26V28.96L14.68 34.44H14.6L11.04 29V37H7.24Z"
        fillOpacity="0.9"
      />
      <path
        d="M32.24 37V23H43.44V26.4H36.12V28.78H42.74V32H36.12V37H32.24Z"
        fillOpacity="0.9"
      />
      <path d="M23.8 32.42V29.08H30.36V32.42H23.8Z" fillOpacity="0.9" />
    </svg>
  );
};
export const WorkSat = ({ className }) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="#121218"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M44.8472 1.9084H43.1327C43.177 1.76641 43.2228 1.62443 43.2228 1.46718C43.2228 0.658015 42.5633 0 41.7526 0C40.9419 0 40.2854 0.658015 40.2854 1.46718C40.2854 1.62443 40.3281 1.76641 40.3755 1.9084H34.7572C34.8014 1.76641 34.8472 1.62443 34.8472 1.46718C34.8442 0.658015 34.1877 0 33.3755 0C32.5663 0 31.9083 0.658015 31.9083 1.46718C31.9083 1.62443 31.9526 1.76641 31.9984 1.9084H26.377C26.4213 1.76641 26.4671 1.62443 26.4671 1.46718C26.4671 0.658015 25.8106 0 24.9999 0C24.1892 0 23.5327 0.658015 23.5327 1.46718C23.5327 1.62443 23.5755 1.76641 23.6213 1.9084H18.0014C18.0457 1.76641 18.0915 1.62443 18.0915 1.46718C18.0915 0.658015 17.4335 0 16.6243 0C15.8136 0 15.1556 0.658015 15.1556 1.46718C15.1556 1.62443 15.1984 1.76641 15.2442 1.9084H9.62586C9.67166 1.76641 9.71593 1.62443 9.71593 1.46718C9.71593 0.656489 9.05944 0 8.24876 0C7.43807 0 6.78006 0.658015 6.78006 1.46718C6.78006 1.62443 6.8228 1.76641 6.86861 1.9084H5.15258C2.83502 1.9084 0.954102 3.79084 0.954102 6.10687V45.8015C0.954102 48.1191 2.83502 50 5.15258 50H40.1068L49.0457 41.0611V6.10687C49.0457 3.79084 47.1648 1.9084 44.8472 1.9084ZM46.7556 40.1115L46.2808 40.5863H42.6854C41.003 40.5863 39.632 41.9603 39.632 43.6397V47.2351L39.1572 47.7099H5.15258C4.10067 47.7099 3.24418 46.8534 3.24418 45.8015V13.7405H46.7556V40.1115Z"
        fillOpacity="0.9"
      />
      <path
        d="M14.0853 33.8853C13.6991 33.8853 13.2792 33.7846 12.9601 33.5831C12.6243 33.3815 12.3892 33.0624 12.3052 32.6258H8.50977C8.59374 34.809 10.6762 36.6731 13.867 36.6731C17.1937 36.6731 19.5281 35.3113 19.5281 32.5067C19.5281 28.1067 12.5739 29.2304 12.5739 27.4182C12.5739 26.9815 12.9601 26.7296 13.8334 26.7296C14.2197 26.7296 14.5724 26.7968 14.8579 26.9479C15.1434 27.1006 15.3617 27.3525 15.4289 27.7739H19.1922C18.9052 25.6579 17.3785 23.9434 14.0182 23.9434C10.9953 23.9434 8.77694 25.2365 8.77694 27.8075C8.77694 32.4258 15.7311 31.1663 15.7311 32.9953C15.7311 33.5663 15.0762 33.8853 14.0853 33.8853Z"
        fillOpacity="0.9"
      />
      <path
        d="M23.3037 36.3539L23.7571 34.7585H27.7037L28.177 36.3539H32.122L27.7892 24.2607H23.7571L19.4243 36.3539H23.3037ZM25.7388 27.9035L27.0152 32.2378H24.5129L25.7388 27.9035Z"
        fillOpacity="0.9"
      />
      <path
        d="M34.0013 36.3539H37.9646V27.4348H41.5249V24.2607H30.4395V27.4348H34.0013V36.3539Z"
        fillOpacity="0.9"
      />
    </svg>
  );
};
export const Cloud = ({ className }) => {
  return (
    <svg
      width="31"
      height="20"
      viewBox="0 0 31 20"
      fill="#131313"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17.247 0.0368786C16.0748 0.173132 15.0043 0.574593 14.0622 1.23882C13.4858 1.64272 12.9094 2.20476 12.5195 2.74248C12.4638 2.82033 12.4129 2.88846 12.4105 2.89333C12.4056 2.89819 12.3136 2.87386 12.207 2.83737C11.9237 2.74491 11.5773 2.65975 11.2746 2.61352C10.9113 2.55756 10.2041 2.55756 9.84571 2.61352C8.36594 2.84223 7.11625 3.64272 6.29039 4.88603C5.72125 5.74491 5.41367 6.8544 5.45727 7.8763L5.4718 8.19746L5.3943 8.20963C5.3507 8.21693 5.21992 8.23396 5.09883 8.24856C4.0986 8.37021 3.01359 8.83737 2.19016 9.5016C1.13906 10.3507 0.402813 11.56 0.126719 12.8958C0.034688 13.341 0.0128911 13.5576 0.015313 14.1001C0.015313 14.6914 0.0492192 14.9955 0.167891 15.4894C0.703126 17.6768 2.43477 19.3799 4.61203 19.8544C5.2611 19.9955 4.60719 19.9882 15.1133 19.9882C24.3309 19.9882 24.8274 19.9858 25.1035 19.9444C26.6753 19.7084 28.0025 19.0369 29.0633 17.9396C29.4072 17.5868 29.5888 17.3629 29.848 16.9761C30.4123 16.1342 30.7707 15.2048 30.933 14.1488C30.9766 13.8666 30.9863 13.7035 30.9863 13.1877C30.9863 12.5016 30.9475 12.1658 30.807 11.5892C30.3711 9.79357 29.2498 8.27289 27.6634 7.32642C26.857 6.84466 25.9318 6.53323 24.9897 6.42374C24.7063 6.38968 24.7039 6.38968 24.7039 6.2072C24.7039 5.97605 24.561 5.22666 24.4448 4.8544C24.2631 4.26316 23.9483 3.57946 23.6431 3.11474C22.5484 1.4432 20.8822 0.367779 18.9277 0.0733757C18.4797 0.00524902 17.6684 -0.0117836 17.247 0.0368786Z"
        fillOpacity="0.5"
      />
    </svg>
  );
};
export const Bubble = ({ className }) => {
  return (
    <svg
      width="21"
      height="31"
      viewBox="0 0 21 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="14" cy="8" r="4" fill="#1E9EE7" fillOpacity="0.5" />
      <circle cx="19.5" cy="12.5" r="1.5" fill="#1E9EE7" fillOpacity="0.5" />
      <circle cx="18.5" cy="1.5" r="1.5" fill="#1E9EE7" fillOpacity="0.5" />
      <circle cx="19.5" cy="19.5" r="1.5" fill="#1E9EE7" fillOpacity="0.5" />
      <circle cx="17.5" cy="23.5" r="1.5" fill="#1E9EE7" fillOpacity="0.5" />
      <circle cx="10" cy="27" r="4" fill="#1E9EE7" fillOpacity="0.5" />
      <circle cx="15.5" cy="28.5" r="2.5" fill="#1E9EE7" fillOpacity="0.5" />
      <circle cx="4" cy="10" r="4" fill="#1E9EE7" fillOpacity="0.5" />
      <circle cx="4" cy="26" r="3" fill="#1E9EE7" fillOpacity="0.5" />
      <circle cx="11" cy="17" r="7" fill="#74CCFF" fillOpacity="0.5" />
    </svg>
  );
};
export const LogoSvg = ({ className }) => {
  return (
    <svg
      width="117"
      height="67"
      viewBox="0 0 117 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M70.175 8H67.3V5.5H75.8V8H72.925V23H70.175V8ZM77.1314 5.5H84.6314V8H79.8814V12.625H83.6564V15.125H79.8814V20.5H84.6314V23H77.1314V5.5ZM86.2135 5.5H88.9635V12.625H91.9135V5.5H94.6635V23H91.9135V15.125H88.9635V23H86.2135V5.5ZM96.7115 5.5H100.162L102.837 15.975H102.887V5.5H105.337V23H102.512L99.2115 10.225H99.1615V23H96.7115V5.5ZM111.355 23.25C110.005 23.25 108.972 22.8667 108.255 22.1C107.539 21.3333 107.18 20.25 107.18 18.85V9.65C107.18 8.25 107.539 7.16667 108.255 6.4C108.972 5.63333 110.005 5.25 111.355 5.25C112.705 5.25 113.739 5.63333 114.455 6.4C115.172 7.16667 115.53 8.25 115.53 9.65V18.85C115.53 20.25 115.172 21.3333 114.455 22.1C113.739 22.8667 112.705 23.25 111.355 23.25ZM111.355 20.75C112.305 20.75 112.78 20.175 112.78 19.025V9.475C112.78 8.325 112.305 7.75 111.355 7.75C110.405 7.75 109.93 8.325 109.93 9.475V19.025C109.93 20.175 110.405 20.75 111.355 20.75ZM70.175 46H67.3V43.5H75.8V46H72.925V61H70.175V46ZM81.1064 61.25C79.7564 61.25 78.7231 60.8667 78.0064 60.1C77.2898 59.3333 76.9314 58.25 76.9314 56.85V47.65C76.9314 46.25 77.2898 45.1667 78.0064 44.4C78.7231 43.6333 79.7564 43.25 81.1064 43.25C82.4564 43.25 83.4898 43.6333 84.2064 44.4C84.9231 45.1667 85.2814 46.25 85.2814 47.65V56.85C85.2814 58.25 84.9231 59.3333 84.2064 60.1C83.4898 60.8667 82.4564 61.25 81.1064 61.25ZM81.1064 58.75C82.0564 58.75 82.5314 58.175 82.5314 57.025V47.475C82.5314 46.325 82.0564 45.75 81.1064 45.75C80.1564 45.75 79.6814 46.325 79.6814 47.475V57.025C79.6814 58.175 80.1564 58.75 81.1064 58.75ZM87.1412 43.5H91.2162C92.6329 43.5 93.6662 43.8333 94.3162 44.5C94.9662 45.15 95.2912 46.1583 95.2912 47.525V48.6C95.2912 50.4167 94.6912 51.5667 93.4912 52.05V52.1C94.1579 52.3 94.6245 52.7083 94.8912 53.325C95.1745 53.9417 95.3162 54.7667 95.3162 55.8V58.875C95.3162 59.375 95.3329 59.7833 95.3662 60.1C95.3995 60.4 95.4829 60.7 95.6162 61H92.8162C92.7162 60.7167 92.6495 60.45 92.6162 60.2C92.5829 59.95 92.5662 59.5 92.5662 58.85V55.65C92.5662 54.85 92.4329 54.2917 92.1662 53.975C91.9162 53.6583 91.4745 53.5 90.8412 53.5H89.8912V61H87.1412V43.5ZM90.8912 51C91.4412 51 91.8495 50.8583 92.1162 50.575C92.3995 50.2917 92.5412 49.8167 92.5412 49.15V47.8C92.5412 47.1667 92.4245 46.7083 92.1912 46.425C91.9745 46.1417 91.6245 46 91.1412 46H89.8912V51H90.8912ZM101.124 61.25C99.7909 61.25 98.7742 60.875 98.0742 60.125C97.3742 59.3583 97.0242 58.2667 97.0242 56.85V47.65C97.0242 46.2333 97.3742 45.15 98.0742 44.4C98.7742 43.6333 99.7909 43.25 101.124 43.25C102.458 43.25 103.474 43.6333 104.174 44.4C104.874 45.15 105.224 46.2333 105.224 47.65V49.15H102.624V47.475C102.624 46.325 102.149 45.75 101.199 45.75C100.249 45.75 99.7742 46.325 99.7742 47.475V57.05C99.7742 58.1833 100.249 58.75 101.199 58.75C102.149 58.75 102.624 58.1833 102.624 57.05V53.625H101.249V51.125H105.224V56.85C105.224 58.2667 104.874 59.3583 104.174 60.125C103.474 60.875 102.458 61.25 101.124 61.25Z"
        fill="white"
      />
      <path
        d="M79.9328 42.25C78.5995 42.25 77.5828 41.875 76.8828 41.125C76.1828 40.3583 75.8328 39.2667 75.8328 37.85V28.65C75.8328 27.2333 76.1828 26.15 76.8828 25.4C77.5828 24.6333 78.5995 24.25 79.9328 24.25C81.2661 24.25 82.2828 24.6333 82.9828 25.4C83.6828 26.15 84.0328 27.2333 84.0328 28.65V30.15H81.4328V28.475C81.4328 27.325 80.9578 26.75 80.0078 26.75C79.0578 26.75 78.5828 27.325 78.5828 28.475V38.05C78.5828 39.1833 79.0578 39.75 80.0078 39.75C80.9578 39.75 81.4328 39.1833 81.4328 38.05V34.625H80.0578V32.125H84.0328V37.85C84.0328 39.2667 83.6828 40.3583 82.9828 41.125C82.2828 41.875 81.2661 42.25 79.9328 42.25ZM91.1734 24.5H94.8984L97.7484 42H94.9984L94.4984 38.525V38.575H91.3734L90.8734 42H88.3234L91.1734 24.5ZM94.1734 36.2L92.9484 27.55H92.8984L91.6984 36.2H94.1734ZM101.88 39.55L106.98 27H102.13V24.5H109.93V26.95L104.83 39.5H109.93V42H101.88V39.55Z"
        fill="#08BFB8"
      />
      <path
        d="M66 33.5C66 15.5507 51.4493 1 33.5 1C15.5507 1 1 15.5507 1 33.5C1 51.4493 15.5507 66 33.5 66C51.4493 66 66 51.4493 66 33.5Z"
        fill="url(#pattern0)"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M47.2203 60.4109H42.1711C40.498 60.4109 39.1416 57.4612 39.1416 53.8226V18.7814C39.1407 16.6515 39.6134 14.652 40.4104 13.4141L42.1494 10.7129C42.4923 10.1828 42.9026 9.89872 43.3233 9.9004H46.0681C46.489 9.90033 46.8995 10.1864 47.242 10.7184L48.9809 13.4196C49.7772 14.6564 50.2498 16.6534 50.2498 18.7814V53.8226C50.2498 57.4612 48.8935 60.4109 47.2203 60.4109Z"
        fill="#0D0E0F"
      />
      <path
        d="M48.9804 13.4142L47.2414 10.713C46.8985 10.1829 46.4882 9.89878 46.0675 9.90046L44.5527 9.90039C44.9737 9.90039 45.3841 10.1864 45.7266 10.7185L47.4656 13.4197C48.2619 14.6565 48.7345 16.6535 48.7345 18.7815V53.8226C48.7345 57.4613 47.3781 60.411 45.7049 60.411H47.2197C48.8929 60.411 50.2492 57.4613 50.2492 53.8226V18.7815C50.2501 16.6515 49.7774 14.6521 48.9804 13.4142Z"
        fill="#1B1C1D"
      />
      <path
        d="M46.4529 5.58398H42.8795C42.6329 5.58398 42.4329 6.08394 42.4329 6.70069V8.934C42.4329 9.55073 42.6329 10.0507 42.8795 10.0507H46.4529C46.6996 10.0507 46.8995 9.55073 46.8995 8.934V6.70069C46.8995 6.08394 46.6996 5.58398 46.4529 5.58398Z"
        fill="#BDA170"
      />
      <path
        d="M46.3413 5.58398H44.6663C44.9747 5.58398 45.2246 6.08394 45.2246 6.70069V8.934C45.2246 9.55073 44.9747 10.0507 44.6663 10.0507H46.3413C46.6497 10.0507 46.8996 9.55073 46.8996 8.934V6.70069C46.8996 6.08394 46.6497 5.58398 46.3413 5.58398Z"
        fill="#8B7550"
      />
      <path
        d="M46.7154 26.373H42.6761C42.3972 26.373 42.1711 26.8647 42.1711 27.4711V31.8633C42.1711 32.4698 42.3972 32.9614 42.6761 32.9614H46.7154C46.9943 32.9614 47.2203 32.4698 47.2203 31.8633V27.4711C47.2203 26.8647 46.9943 26.373 46.7154 26.373Z"
        fill="#F5F5F5"
      />
      <path
        d="M24.8287 60.4119H19.7795C18.1063 60.4119 16.75 57.4622 16.75 53.8236V18.7824C16.7491 16.6525 17.2218 14.653 18.0188 13.4151L19.7578 10.7139C20.1007 10.1838 20.511 9.89977 20.9317 9.90137H23.6765C24.0974 9.90137 24.5078 10.1873 24.8504 10.7194L26.5893 13.4206C27.3856 14.6574 27.8582 16.6544 27.8582 18.7824V53.8236C27.8582 57.4622 26.5018 60.4119 24.8287 60.4119Z"
        fill="#238CBC"
      />
      <path
        d="M26.5888 13.4151L24.8498 10.7139C24.5069 10.1838 24.0966 9.89977 23.6759 9.90137H22.1611C22.5821 9.90137 22.9925 10.1873 23.335 10.7194L25.074 13.4206C25.8703 14.6574 26.3429 16.6544 26.3428 18.7824V53.8236C26.3428 57.4622 24.9865 60.4119 23.3133 60.4119H24.8281C26.5013 60.4119 27.8576 57.4622 27.8576 53.8236V18.7824C27.8585 16.6525 27.3858 14.653 26.5888 13.4151Z"
        fill="#084E6D"
      />
      <path
        d="M24.1201 5.58398H20.5468C20.3001 5.58398 20.1001 6.08393 20.1001 6.70065V8.93396C20.1001 9.5507 20.3001 10.0507 20.5468 10.0507H24.1201C24.3668 10.0507 24.5668 9.5507 24.5668 8.93396V6.70065C24.5668 6.08393 24.3668 5.58398 24.1201 5.58398Z"
        fill="#BDA170"
      />
      <path
        d="M24.0085 5.58398H22.3335C22.6418 5.58398 22.8918 6.08393 22.8918 6.70065V8.93396C22.8918 9.5507 22.6418 10.0507 22.3335 10.0507H24.0085C24.3168 10.0507 24.5668 9.5507 24.5668 8.93396V6.70065C24.5668 6.08393 24.3168 5.58398 24.0085 5.58398Z"
        fill="#8B7550"
      />
      <path
        d="M24.3235 26.373H20.2842C20.0054 26.373 19.7793 26.8647 19.7793 27.4711V31.8634C19.7793 32.4698 20.0054 32.9614 20.2842 32.9614H24.3235C24.6024 32.9614 24.8285 32.4698 24.8285 31.8634V27.4711C24.8285 26.8647 24.6024 26.373 24.3235 26.373Z"
        fill="#F5F5F5"
      />
      <path
        d="M35.938 60.4119H30.8888C29.2157 60.4119 27.8594 57.4622 27.8594 53.8236V18.7824C27.8585 16.6525 28.3312 14.653 29.1282 13.4151L30.8671 10.7139C31.21 10.1838 31.6204 9.89977 32.041 9.90137H34.7858C35.2067 9.90137 35.6172 10.1873 35.9597 10.7194L37.6987 13.4206C38.495 14.6574 38.9676 16.6544 38.9675 18.7824V53.8236C38.9675 57.4622 37.6112 60.4119 35.938 60.4119Z"
        fill="#7F8E94"
      />
      <path
        d="M37.6979 13.4151L35.959 10.7139C35.6161 10.1838 35.2057 9.89977 34.785 9.90137H33.2703C33.6912 9.90137 34.1017 10.1873 34.4442 10.7194L36.1832 13.4206C36.9795 14.6574 37.4521 16.6544 37.452 18.7824V53.8236C37.452 57.4622 36.0957 60.4119 34.4225 60.4119H35.9373C37.6104 60.4119 38.9667 57.4622 38.9667 53.8236V18.7824C38.9676 16.6525 38.4949 14.653 37.6979 13.4151Z"
        fill="#545C60"
      />
      <path
        d="M35.2866 5.58398H31.7133C31.4666 5.58398 31.2666 6.08393 31.2666 6.70065V8.93396C31.2666 9.5507 31.4666 10.0507 31.7133 10.0507H35.2866C35.5333 10.0507 35.7333 9.5507 35.7333 8.93396V6.70065C35.7333 6.08393 35.5333 5.58398 35.2866 5.58398Z"
        fill="#BDA170"
      />
      <path
        d="M35.175 5.58398H33.5C33.8083 5.58398 34.0583 6.08393 34.0583 6.70065V8.93396C34.0583 9.5507 33.8083 10.0507 33.5 10.0507H35.175C35.4833 10.0507 35.7333 9.5507 35.7333 8.93396V6.70065C35.7333 6.08393 35.4833 5.58398 35.175 5.58398Z"
        fill="#8B7550"
      />
      <path
        d="M35.431 26.373H31.3916C31.1128 26.373 30.8867 26.8647 30.8867 27.4711V31.8634C30.8867 32.4698 31.1128 32.9614 31.3916 32.9614H35.431C35.7098 32.9614 35.9359 32.4698 35.9359 31.8634V27.4711C35.9359 26.8647 35.7098 26.373 35.431 26.373Z"
        fill="#F5F5F5"
      />
      <path
        d="M44.1846 29.5527H43.5092V29.0837C43.5092 29.0055 43.4686 28.9665 43.3873 28.9665H43.195C43.1106 28.9665 43.0684 29.0055 43.0684 29.0837V30.9128C43.0684 30.9566 43.0778 30.9878 43.0965 31.0066C43.1153 31.0222 43.1481 31.0301 43.195 31.0301H43.3873C43.4311 31.0301 43.4623 31.0222 43.4811 31.0066C43.4999 30.9878 43.5092 30.9566 43.5092 30.9128V30.4579H44.1846V30.9738C44.1846 31.3177 43.9861 31.4897 43.589 31.4897H42.9886C42.5947 31.4897 42.3977 31.3177 42.3977 30.9738V29.0227C42.3977 28.6788 42.5947 28.5068 42.9886 28.5068H43.589C43.9861 28.5068 44.1846 28.6788 44.1846 29.0227V29.5527ZM45.1095 28.5068H45.7379C46.1319 28.5068 46.3289 28.6788 46.3289 29.0227V30.9691C46.3289 31.3161 46.1319 31.4897 45.7379 31.4897H45.1095C44.7124 31.4897 44.5138 31.3161 44.5138 30.9691V29.0227C44.5138 28.6788 44.7124 28.5068 45.1095 28.5068ZM45.6582 30.88V29.1165C45.6582 29.0383 45.6175 28.9993 45.5363 28.9993H45.3111C45.2267 28.9993 45.1845 29.0383 45.1845 29.1165V30.88C45.1845 30.9582 45.2267 30.9972 45.3111 30.9972H45.5363C45.6175 30.9972 45.6582 30.9582 45.6582 30.88ZM46.8556 30.4726V30.6415H46.5682V30.4324C46.5682 30.285 46.6526 30.2113 46.8215 30.2113H47.0385C47.2101 30.2113 47.2958 30.285 47.2958 30.4324V30.5952C47.2958 30.6569 47.2864 30.7105 47.2677 30.756C47.2503 30.8002 47.2214 30.8492 47.1812 30.9028L46.924 31.2786H47.2998V31.4897H46.5742V31.2947L46.928 30.8203C46.9615 30.7788 46.9836 30.742 46.9943 30.7098C47.0064 30.6776 47.0124 30.6381 47.0124 30.5912V30.4726C47.0124 30.4391 46.9943 30.4224 46.9581 30.4224H46.9079C46.873 30.4224 46.8556 30.4391 46.8556 30.4726Z"
        fill="#002BC2"
      />
      <path
        d="M21.5578 28.5068H22.1862C22.5802 28.5068 22.7772 28.6788 22.7772 29.0227V30.9691C22.7772 31.3161 22.5802 31.4897 22.1862 31.4897H21.5578C21.1607 31.4897 20.9622 31.3161 20.9622 30.9691V29.0227C20.9622 28.6788 21.1607 28.5068 21.5578 28.5068ZM22.1065 30.88V29.1165C22.1065 29.0383 22.0658 28.9993 21.9846 28.9993H21.7595C21.675 28.9993 21.6328 29.0383 21.6328 29.1165V30.88C21.6328 30.9582 21.675 30.9972 21.7595 30.9972H21.9846C22.0658 30.9972 22.1065 30.9582 22.1065 30.88ZM23.304 30.4726V30.6415H23.0166V30.4324C23.0166 30.285 23.101 30.2113 23.2698 30.2113H23.4869C23.6584 30.2113 23.7442 30.285 23.7442 30.4324V30.5952C23.7442 30.6569 23.7348 30.7105 23.7161 30.756C23.6986 30.8002 23.6698 30.8492 23.6296 30.9028L23.3723 31.2786H23.7482V31.4897H23.0226V31.2947L23.3764 30.8203C23.4099 30.7788 23.432 30.742 23.4427 30.7098C23.4548 30.6776 23.4608 30.6381 23.4608 30.5912V30.4726C23.4608 30.4391 23.4427 30.4224 23.4065 30.4224H23.3563C23.3214 30.4224 23.304 30.4391 23.304 30.4726Z"
        fill="#002BC2"
      />
      <path
        d="M33.3961 31.4897L33.2929 30.9503H32.6129L32.5097 31.4897H31.8484L32.5237 28.5068H33.3773L34.0714 31.4897H33.3961ZM32.7067 30.4626H33.1944L32.9505 29.201L32.7067 30.4626ZM35.3865 29.1541H35.4663V29.7215H35.2364C35.0395 29.7215 34.941 29.831 34.941 30.0498V31.4897H34.2891V29.1681H34.9316V29.5011C34.9566 29.3979 35.0082 29.3151 35.0864 29.2525C35.1646 29.1869 35.2646 29.1541 35.3865 29.1541Z"
        fill="#002BC2"
      />
      <path
        d="M67 33.5C67 52.0015 52.4435 67 34.4871 67C16.5307 67 58.2649 38.0015 58.2649 19.5C58.2649 0.998461 16.5307 0 34.4871 0C52.4435 0 67 14.9985 67 33.5Z"
        fill="white"
      />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use transform="translate(-0.3) scale(0.003125)" />
        </pattern>
        <image id="image0_1264_381" width="512" height="320" />
      </defs>
    </svg>
  );
};
export const LogoFooter = ({ className }) => {
  return (
    <svg
      width="49"
      height="57"
      viewBox="0 0 49 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.175 3H0.3V0.499999H8.8V3H5.925V18H3.175V3ZM10.1314 0.499999H17.6314V3H12.8814V7.625H16.6564V10.125H12.8814V15.5H17.6314V18H10.1314V0.499999ZM19.2135 0.499999H21.9635V7.625H24.9135V0.499999H27.6635V18H24.9135V10.125H21.9635V18H19.2135V0.499999ZM29.7115 0.499999H33.1615L35.8365 10.975H35.8865V0.499999H38.3365V18H35.5115L32.2115 5.225H32.1615V18H29.7115V0.499999ZM44.3555 18.25C43.0055 18.25 41.9721 17.8667 41.2555 17.1C40.5388 16.3333 40.1805 15.25 40.1805 13.85V4.65C40.1805 3.25 40.5388 2.16667 41.2555 1.4C41.9721 0.633332 43.0055 0.249999 44.3555 0.249999C45.7055 0.249999 46.7388 0.633332 47.4555 1.4C48.1721 2.16667 48.5305 3.25 48.5305 4.65V13.85C48.5305 15.25 48.1721 16.3333 47.4555 17.1C46.7388 17.8667 45.7055 18.25 44.3555 18.25ZM44.3555 15.75C45.3055 15.75 45.7805 15.175 45.7805 14.025V4.475C45.7805 3.325 45.3055 2.75 44.3555 2.75C43.4055 2.75 42.9305 3.325 42.9305 4.475V14.025C42.9305 15.175 43.4055 15.75 44.3555 15.75ZM3.175 41H0.3V38.5H8.8V41H5.925V56H3.175V41ZM14.1064 56.25C12.7564 56.25 11.7231 55.8667 11.0064 55.1C10.2898 54.3333 9.93145 53.25 9.93145 51.85V42.65C9.93145 41.25 10.2898 40.1667 11.0064 39.4C11.7231 38.6333 12.7564 38.25 14.1064 38.25C15.4564 38.25 16.4898 38.6333 17.2064 39.4C17.9231 40.1667 18.2814 41.25 18.2814 42.65V51.85C18.2814 53.25 17.9231 54.3333 17.2064 55.1C16.4898 55.8667 15.4564 56.25 14.1064 56.25ZM14.1064 53.75C15.0564 53.75 15.5314 53.175 15.5314 52.025V42.475C15.5314 41.325 15.0564 40.75 14.1064 40.75C13.1564 40.75 12.6814 41.325 12.6814 42.475V52.025C12.6814 53.175 13.1564 53.75 14.1064 53.75ZM20.1412 38.5H24.2162C25.6329 38.5 26.6662 38.8333 27.3162 39.5C27.9662 40.15 28.2912 41.1583 28.2912 42.525V43.6C28.2912 45.4167 27.6912 46.5667 26.4912 47.05V47.1C27.1579 47.3 27.6245 47.7083 27.8912 48.325C28.1745 48.9417 28.3162 49.7667 28.3162 50.8V53.875C28.3162 54.375 28.3329 54.7833 28.3662 55.1C28.3995 55.4 28.4829 55.7 28.6162 56H25.8162C25.7162 55.7167 25.6495 55.45 25.6162 55.2C25.5829 54.95 25.5662 54.5 25.5662 53.85V50.65C25.5662 49.85 25.4329 49.2917 25.1662 48.975C24.9162 48.6583 24.4745 48.5 23.8412 48.5H22.8912V56H20.1412V38.5ZM23.8912 46C24.4412 46 24.8495 45.8583 25.1162 45.575C25.3995 45.2917 25.5412 44.8167 25.5412 44.15V42.8C25.5412 42.1667 25.4245 41.7083 25.1912 41.425C24.9745 41.1417 24.6245 41 24.1412 41H22.8912V46H23.8912ZM34.1242 56.25C32.7909 56.25 31.7742 55.875 31.0742 55.125C30.3742 54.3583 30.0242 53.2667 30.0242 51.85V42.65C30.0242 41.2333 30.3742 40.15 31.0742 39.4C31.7742 38.6333 32.7909 38.25 34.1242 38.25C35.4576 38.25 36.4742 38.6333 37.1742 39.4C37.8742 40.15 38.2242 41.2333 38.2242 42.65V44.15H35.6242V42.475C35.6242 41.325 35.1492 40.75 34.1992 40.75C33.2492 40.75 32.7742 41.325 32.7742 42.475V52.05C32.7742 53.1833 33.2492 53.75 34.1992 53.75C35.1492 53.75 35.6242 53.1833 35.6242 52.05V48.625H34.2492V46.125H38.2242V51.85C38.2242 53.2667 37.8742 54.3583 37.1742 55.125C36.4742 55.875 35.4576 56.25 34.1242 56.25Z"
        fill="white"
      />
      <path
        d="M12.9328 37.25C11.5995 37.25 10.5828 36.875 9.88281 36.125C9.18281 35.3583 8.83281 34.2667 8.83281 32.85V23.65C8.83281 22.2333 9.18281 21.15 9.88281 20.4C10.5828 19.6333 11.5995 19.25 12.9328 19.25C14.2661 19.25 15.2828 19.6333 15.9828 20.4C16.6828 21.15 17.0328 22.2333 17.0328 23.65V25.15H14.4328V23.475C14.4328 22.325 13.9578 21.75 13.0078 21.75C12.0578 21.75 11.5828 22.325 11.5828 23.475V33.05C11.5828 34.1833 12.0578 34.75 13.0078 34.75C13.9578 34.75 14.4328 34.1833 14.4328 33.05V29.625H13.0578V27.125H17.0328V32.85C17.0328 34.2667 16.6828 35.3583 15.9828 36.125C15.2828 36.875 14.2661 37.25 12.9328 37.25ZM24.1734 19.5H27.8984L30.7484 37H27.9984L27.4984 33.525V33.575H24.3734L23.8734 37H21.3234L24.1734 19.5ZM27.1734 31.2L25.9484 22.55H25.8984L24.6984 31.2H27.1734ZM34.8803 34.55L39.9803 22H35.1303V19.5H42.9303V21.95L37.8303 34.5H42.9303V37H34.8803V34.55Z"
        fill="#BBBBBB"
      />
    </svg>
  );
};
